


































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Question extends Vue {
  @Prop({ type: Number, required: true }) public readonly number!: number
  @Prop({ type: Number, required: true }) public readonly id!: number

  public $parent: any
  public isActive: boolean = false

  // noinspection JSUnusedLocalSymbols
  private mounted(): void {
    // check if its 1st item, then make it active
    // temporarily disabled
    // if (this.$parent.activeArticle === this.id || this.number === 0) {
    //   this.isActive = true
    // }
  }
}
